import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Loader from '../../components/common/loader';
import { useGetConsultationQuery } from '../../services/users.api';

import { JOURNAL_TAB_GROUP_THERAPY, navigateToJournalSession } from './journal-navigation';

/** Редирект со старых URL `/journal/:id` на новый журнал с открытой сессией. */
export function JournalConsultationRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: consultation, isError } = useGetConsultationQuery(id ?? '', { skip: !id });

  useEffect(() => {
    if (!id) {
      navigate('/journal', { replace: true });
      return;
    }

    if (isError) {
      navigate('/journal', { replace: true });
      return;
    }

    if (consultation) {
      navigateToJournalSession(navigate, consultation.id, consultation.client_entity, 'Инструменты', {
        isClientActive: true,
        replace: true,
        journalTabId: consultation.is_group ? JOURNAL_TAB_GROUP_THERAPY : undefined,
      });
    }
  }, [consultation, id, isError, navigate]);

  return <Loader />;
}
